import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import FadeInSection from "./FadeInSection";

const isHorizontal = window.innerWidth < 600;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  if (isHorizontal) {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  } else {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  if (isHorizontal) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`
    };
  } else {
    return {
      id: `vertical-tab-${index}`
    };
  }
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: "theme.palette.background.paper",
    display: "flex",
    height: 300
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`
  }
}));

const JobList = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const experienceItems = {

    "Dell Technologies": {
      jobTitle: "Software Engineer @",
      duration: "MAR 2024 - PRESENT",
      desc: [
        "Contribute to backend development for edge computing storage solutions, focusing on reliability and scalability.",
        "Work with Golang and SQL to build and optimize key system features.",
        "Collaborate with cross-functional teams to deliver impactful and robust software."
      ]
    },
    "Dell Technologies ": {
      jobTitle: "Software Engineer Intern @",
      duration: "MAY 2023 - AUG 2023",
      desc: [
        "Developed full-stack microservices to automate vSphere virtual machine creation, modification, health checks, and troubleshooting using Python (FastAPI), React.js, vSphere API, Jenkins, InfluxDB, and Docker.",
        "Created a DevOps portal dashboard that enabled developers to effortlessly access detailed information for their virtual machines, streamlining development cycle times using Python (FastAPI), React.js, Docker, and InfluxDB."
      ]
    },
    PhillipNova: {
      jobTitle: "Software Development Intern @",
      duration: "MAY 2022 - AUG 2022",
      desc: [
        "Designed a software system for the Operations and Settlement department to automate the processing the transfer of funds to brokers and bank-to-bank transfers.",
        "Created a data collection system using APIs of services such as MailChimp, Eventbrite and GoToWebinar which is utilized by the Marketing and Communications department.",
        "Carried out requirements gathering and process modelling for a feature enhancement for the Nova Client Trading Portal."
      ]
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Tabs
        orientation={!isHorizontal ? "vertical" : null}
        variant={isHorizontal ? "fullWidth" : "scrollable"}
        value={value}
        onChange={handleChange}
        className={classes.tabs}
      >
        {Object.keys(experienceItems).map((key, i) => (
          <Tab label={isHorizontal ? `0${i}.` : key} {...a11yProps(i)} />
        ))}
      </Tabs>
      {Object.keys(experienceItems).map((key, i) => (
        <TabPanel value={value} index={i}>
          <span className="joblist-job-title">
            {experienceItems[key]["jobTitle"] + " "}
          </span>
          <span className="joblist-job-company">{key}</span>
          <div className="joblist-duration">
            {experienceItems[key]["duration"]}
          </div>
          <ul className="job-description">
            {experienceItems[key]["desc"].map(function (descItem, i) {
              return (
                <FadeInSection delay={`${i + 1}00ms`}>
                  <li key={i}>{descItem}</li>
                </FadeInSection>
              );
            })}
          </ul>
        </TabPanel>
      ))}
    </div>
  );
};

export default JobList;
